import React from 'react';
import Navbar from '../Components/Navbar';
import PageHeader from '../Components/PageHeader';
import Footer from '../Components/Footer';
import { Link } from 'react-router-dom';

const Solutions = () => {
  return (
    <div>
      <Navbar />
      <PageHeader 
        title="Our Solutions" 
        subtitle="Discover the innovative IT solutions that empower your business to thrive in the digital age." 
      />

      {/* Solutions Overview */}
      <section className="py-16 px-6 bg-netbernet-white">
        <div className="container mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-netbernet-black mb-4">Tailored IT Solutions</h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              We provide a range of cutting-edge solutions designed to meet your business needs and drive growth.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {[
              {
                title: "Cloud Computing",
                desc: "Leverage scalable cloud infrastructure to enhance efficiency, reduce costs, and improve flexibility for your business operations.",
                icon: "☁️"
              },
              {
                title: "Web Development",
                desc: "Create modern, responsive, and high-performance websites tailored to your brand and business goals.",
                icon: "🌐"
              },
              {
                title: "Digital Marketing",
                desc: "Boost your online presence with SEO, social media strategies, and targeted campaigns to reach your audience.",
                icon: "📈"
              },
              {
                title: "Cybersecurity",
                desc: "Protect your business with robust security solutions, including threat detection, data encryption, and compliance management.",
                icon: "🔒"
              },
              {
                title: "IT Consulting",
                desc: "Get expert guidance to optimize your IT infrastructure, streamline processes, and align technology with your business objectives.",
                icon: "🤝"
              },
              {
                title: "Mobile App Development",
                desc: "Build intuitive and engaging mobile applications for iOS and Android to connect with your customers on the go.",
                icon: "📱"
              },{
                title: "ERP Solutions",
                desc: "Streamline and integrate your core business processes into a unified system that improves efficiency, enables real-time insights, and supports scalable growth.",
                icon: "🏢"
              },
            ].map((solution, index, arr) => {
                const isLast = index === arr.length - 1;
                return (
                  <div key={index} className={`bg-gray-50 p-6 rounded-xl shadow-md text-center 
                  ${isLast ? "lg:col-start-2" : ""}`}>
                    <div className="w-16 h-16 bg-netbernet-blue rounded-full mx-auto mb-4 flex items-center justify-center text-netbernet-white text-2xl">
                      {solution.icon}
                    </div>
                    <h3 className="text-xl font-semibold mb-4 text-netbernet-black">{solution.title}</h3>
                    <p className="text-gray-600">{solution.desc}</p>
                  </div>
                );
              })}
          </div>
        </div>
      </section>

      {/* Why Choose Our Solutions */}
      <section className="py-16 px-6 bg-netbernet-blue text-netbernet-white">
        <div className="container mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold mb-4">Why Choose Netbernet?</h2>
            <p className="text-xl max-w-3xl mx-auto">
              Our solutions are designed to deliver measurable results, combining innovation, expertise, and a client-centric approach.
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            <div className="bg-netbernet-white bg-opacity-10 p-8 rounded-xl">
              <h3 className="text-2xl font-semibold mb-4">Customized Approach</h3>
              <p className="text-lg leading-relaxed">
                We tailor our solutions to fit your unique business needs, ensuring maximum impact and efficiency.
              </p>
            </div>
            <div className="bg-netbernet-white bg-opacity-10 p-8 rounded-xl">
              <h3 className="text-2xl font-semibold mb-4">Proven Expertise</h3>
              <p className="text-lg leading-relaxed">
                With years of experience and a skilled team, we deliver reliable and innovative solutions that drive success.
              </p>
            </div>
            <div className="bg-netbernet-white bg-opacity-10 p-8 rounded-xl">
              <h3 className="text-2xl font-semibold mb-4">Scalable Solutions</h3>
              <p className="text-lg leading-relaxed">
                Our solutions grow with your business, providing flexibility to adapt to changing demands.
              </p>
            </div>
            <div className="bg-netbernet-white bg-opacity-10 p-8 rounded-xl">
              <h3 className="text-2xl font-semibold mb-4">End-to-End Support</h3>
              <p className="text-lg leading-relaxed">
                From planning to implementation and maintenance, we provide comprehensive support at every step.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="py-16 px-6 bg-gray-100">
        <div className="container mx-auto text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-netbernet-black mb-4">Ready to Transform Your Business?</h2>
          <p className="text-xl text-gray-600 mb-8 max-w-3xl mx-auto">
            Let’s work together to find the perfect IT solutions for your needs. Contact us today to get started.
          </p>
          <Link
            to="/contact"
            className="inline-block bg-netbernet-blue text-netbernet-white py-3 px-8 rounded-lg font-semibold hover:bg-blue-800 transition-colors"
          >
            Get in Touch
          </Link>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Solutions;